document.addEventListener('DOMContentLoaded', () => {
  const card = document.querySelector('.nb-placeholder-card[data-drop-epoch]');
  const countdownEl = document.getElementById('nb-countdown');
  if (!card || !countdownEl) return;

  const epochSeconds = Number(card.getAttribute('data-drop-epoch'));
  if (!epochSeconds) return;

  const target = epochSeconds * 1000; // ms

  const format = (ms) => {
    let diff = Math.max(0, ms);
    const h = String(Math.floor(diff / 3_600_000)).padStart(2,'0');
    diff %= 3_600_000;
    const m = String(Math.floor(diff / 60_000)).padStart(2,'0');
    diff %= 60_000;
    const s = String(Math.floor(diff / 1000)).padStart(2,'0');
    return `${h}:${m}:${s}`;
  };

  let pollTries = 0;
  const maxPolls = 8;          // ~2 minutes fallback polling
  const pollEveryMs = 15_000;

  const tryReloadOrPoll = () => {
    // Immediate reload: in most cases this reveals the newly published product(s)
    setTimeout(() => window.location.reload(), 1500);

    // Fallback polling to beat CDN/browser cache lag
    const poll = setInterval(() => {
      pollTries++;
      fetch(window.location.href, { cache: 'no-store' })
        .then(r => r.text())
        .then(html => {
          // If products are now present, the empty-state markup disappears.
          const stillEmpty = /nb-placeholder-card/.test(html);
          if (!stillEmpty) {
            window.location.replace(window.location.href);
            clearInterval(poll);
          } else if (pollTries >= maxPolls) {
            clearInterval(poll);
          }
        })
        .catch(() => { if (pollTries >= maxPolls) clearInterval(poll); });
    }, pollEveryMs);
  };

  const tick = () => {
    const now = Date.now();
    const remaining = target - now;

    if (remaining <= 0) {
      countdownEl.textContent = '00:00:00';
      clearInterval(timer);
      tryReloadOrPoll();
      return;
    }
    countdownEl.textContent = format(remaining);
  };

  tick();
  const timer = setInterval(tick, 1000);
});
